import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submission24',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css']
})
export class SubmissionComponent24 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
